var h;
export function debounce(func, wait) {
    if (wait === void 0) { wait = 150; }
    return function () {
        clearTimeout(h);
        h = setTimeout(function () { return func(); }, wait);
    };
}
//# sourceMappingURL=utils.js.map